import React, { Component } from 'react';

import './style.scss';
import DetailLabel from 'components/DetailLabel';
import { ChatDocumentShape } from 'entities';

class ChatDocument extends Component {

  render() {
    const chatDocument = this.props.chatDocument;

    return (
      <div className="ChatResource ChatDocument">
        <div className="preview">
          <div className="content">
            <a className="Link" target="_blank" href={chatDocument.url}>{chatDocument.name}</a>
          </div>
        </div>

        <DetailLabel>{__('members.chat.items.documentHelp')}</DetailLabel>
      </div>
    );
  }
}

ChatDocument.propTypes = {
  chatDocument: ChatDocumentShape
};

export default ChatDocument;



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/ChatDocument/index.js
 **/